import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import {
  RequirementContextType,
  RequirementStatusViewProps
} from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";

export const getInsuranceCoverageRequirementStatus = (
  requirement: IRequirementResponse,
  insuranceCoverage: InsuranceCoverageMonitor | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (requirement.status === "Complete") {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (
    insuranceCoverage?.status === "Monitoring" ||
    insuranceCoverage?.status === "Pending"
  ) {
    if (contextType === RequirementContextType.Payer) {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    } else {
      pill = {
        theme: "warning",
        text: "Awaiting contractor",
        icon: true
      };
      secondaryText = "Awaiting contractor completion";
    }
  } else {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
  }

  return {
    pill,
    secondaryText
  };
};
